import Button from '@lyra/core/components/Button'
import DropdownButton from '@lyra/core/components/DropdownButton'
import { MoreVertical } from '@lyra/core/components/Icon'
import useSubaccount from '@lyra/web/hooks/useSubaccount'
import useTransaction from '@lyra/web/hooks/useTransaction'
import { Order } from '@lyra/web/src/constants/order'
import React, { useState } from 'react'
import { XStack } from 'tamagui'

import EditOrderModal from '../EditOrderModal'
import EnableTradingModal from '../EnableTradingModal'

type Props = {
  order: Order
}

const OpenOrderActions = ({ order }: Props): JSX.Element => {
  const { sessionKey } = useTransaction()
  const { cancelOrder, cancelTriggerOrder } = useSubaccount()

  const [isEnableTradingOpen, setIsEnableTradingOpen] = useState(false)
  const [isEditOrderOpen, setIsEditOrderOpen] = useState(false)

  return (
    <XStack gap="$2">
      <Button
        label="Cancel"
        onPress={async () => {
          if (sessionKey) {
            if (order.trigger_type && order.order_status === 'untriggered') {
              await cancelTriggerOrder(order.order_id, order.instrument_name)
            } else {
              await cancelOrder(order.order_id, order.instrument_name)
            }
          } else {
            setIsEnableTradingOpen(true)
          }
        }}
      />
      <DropdownButton icon={<MoreVertical />} isPortaled>
        <DropdownButton.ListItem
          label="Edit"
          isDisabled={!!order.trigger_type}
          onPress={() => setIsEditOrderOpen(true)}
        />
      </DropdownButton>
      {isEditOrderOpen ? (
        <EditOrderModal order={order} onClose={() => setIsEditOrderOpen(false)} />
      ) : null}
      {!sessionKey && isEnableTradingOpen ? (
        <EnableTradingModal onClose={() => setIsEnableTradingOpen(false)} />
      ) : null}
    </XStack>
  )
}

export default OpenOrderActions
